import { GzRmOldestVulnerabilitiesWidgetWebComponent } from './component/GzRmOldestVulnerabilitiesWidgetWebComponent';

export { GzRmOldestVulnerabilitiesWidgetWebComponent };
